// extracted by mini-css-extract-plugin
module.exports = {"value":"TrailerNumberLabel_value__3oK4G","label":"TrailerNumberLabel_label__1RIZA"};